import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Index = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Show login page as home
    navigate("/login");
  }, [navigate]);

  return null;
};

export default Index;
